








































import { Component, Vue } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import moment from 'moment';
import 'moment/locale/de';
import { Event } from '../interfaces/events';

@Component({
})
export default class EventList extends Vue {
  @Prop({ default: [] }) readonly events!: Event[];

  // eslint-disable-next-line class-methods-use-this
  formatChangedDate(tstamp: number) {
    return moment.unix(tstamp).format('DD.MM.YYYY');
  }

  // eslint-disable-next-line class-methods-use-this
  categoryId(event: Event): number {
    if (!event.categories.length) {
      return 0;
    }
    const category = event.categories[0];
    if (category === undefined) {
      return 0;
    }
    return category.uid;
  }
}
